import React, { FC } from 'react';

import { SoBannerItem, SoBannerPageProps } from '../../../models';
import {
  ImageVariant,
  ProductVariant,
  RecipeVariant,
  TextRightVariant,
  TextVariant,
} from '../../items';

const SliderPage: FC<SoBannerPageProps> = ({ items, indexPage }) => (
  <div className="SliderPage" key={indexPage}>
    {items.map((item: SoBannerItem, index: number) => {
      const { variant } = item;
      switch (variant[0]) {
        case 'text':
          return <TextVariant data={item} index={index} />;
        case 'textRight':
          return <TextRightVariant data={item} index={index} />;
        case 'product':
          return <ProductVariant data={item} index={index} />;
        case 'recipe':
          return <RecipeVariant data={item} index={index} />;
        case 'image':
          return <ImageVariant data={item} index={index} />;
        default:
          return <>{variant}</>;
      }
    })}
  </div>
);

export default SliderPage;
